import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SuccessfulInviteModal from './SuccessfulInviteModal';
import InviteForm from './InviteForm';

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            invitedContest: null,
        };
        this.handleSuccess = this.handleSuccess.bind(this);
    }

    closeModal() {
        this.setState(() => ({ showModal: false }));
    }

    handleSuccess(invitedContest) {
        this.setState(() => ({
            showModal: true,
            invitedContest,
        }));
    }

    successModal() {
        if (!this.state.invitedContest) return null;
        return (
            <SuccessfulInviteModal
                isActive={this.state.showModal}
                findDesignersUrl={this.props.findDesignersUrl}
                favoriteDesignersUrl={this.props.favoriteDesignersUrl}
                onClose={this.closeModal}
                contest={this.state.invitedContest}
            />
        );
    }

    render() {
        return (
            <div className="two-column-layout">
                <div className="two-column-layout__header">
                    <h3 className="two-column-layout__heading">
                        <FormattedMessage id="invite_to_contest" />
                    </h3>
                </div>
                <div className="two-column-layout__body">
                    <div className="section">
                        <InviteForm
                            handleSuccess={this.handleSuccess}
                            designerId={this.props.designerId}
                            contests={this.props.contests}
                            inviteDesignerUrl={this.props.inviteDesignerUrl}
                        />
                        {this.successModal()}
                    </div>
                </div>
            </div>
        );
    }
}

App.propTypes = {
    inviteDesignerUrl: PropTypes.string.isRequired,
    findDesignersUrl: PropTypes.string.isRequired,
    favoriteDesignersUrl: PropTypes.string.isRequired,
    designerId: PropTypes.number.isRequired,
    contests: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            remainingInvites: PropTypes.number.isRequired,
            timeRemaining: PropTypes.string.isRequired,
            ineligibilityReason: PropTypes.shape({
                className: PropTypes.string,
                iconName: PropTypes.string,
                linkUrl: PropTypes.string,
                message: PropTypes.string,
                linkMessage: PropTypes.string,
            }),
        })
    ).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/invite-designer/components/app.jsx